window.addEventListener('load', function () {
  setTimeout(function () {
    var bodyTarget = document.querySelector("body");
    bodyTarget.classList.add("is-active");
  }, 1000);
});